import { render, staticRenderFns } from "./BulkSchemaCreate.vue?vue&type=template&id=b55961ac&scoped=true&"
import script from "./BulkSchemaCreate.vue?vue&type=script&lang=ts&"
export * from "./BulkSchemaCreate.vue?vue&type=script&lang=ts&"
import style0 from "./BulkSchemaCreate.vue?vue&type=style&index=0&id=b55961ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55961ac",
  null
  
)

export default component.exports